import React from 'react';
export function Footer() {
  return <footer className="bg-navy-950 py-12 text-cream-200/40 text-sm" data-id="element-60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-61">
        {/* Disclaimer */}
        <div className="border-t border-navy-800 pt-6 mb-8 text-center text-xs text-cream-200/30 leading-relaxed max-w-3xl mx-auto space-y-1" data-id="element-62">
          <p data-id="element-63">
            Este producto es únicamente educativo e informativo. No constituye
            asesoría financiera, legal ni hipotecaria.
          </p>
          <p data-id="element-64">
            Los resultados pueden variar según tu situación particular. Consulta
            siempre con un profesional licenciado antes de tomar decisiones
            financieras.
          </p>
          <p data-id="element-65">
            Triángulo Cash Real™ no se hace responsable por decisiones tomadas
            con base en este material.
          </p>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-66">
          <p data-id="element-67">© 2024 Triángulo Cash Real™. Todos los derechos reservados.</p>
          <div className="flex gap-6" data-id="element-68">
            <a href="#" className="hover:text-gold-400 transition-colors" data-id="element-69">
              Términos
            </a>
            <a href="#" className="hover:text-gold-400 transition-colors" data-id="element-70">
              Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}